// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DiSU","colBig":"styles_colBig__1_Jba","colSmall":"styles_colSmall__1lM-7","shopifyNameWrapper":"styles_shopifyNameWrapper__1PdOj"};